import DAO from './DAO.js';
import StoreItemProcessing from '../helpers/StoreFunctions/StoreItemProcessing';
import _ from 'lodash';

export default class RolesDAO extends DAO {

  constructor(store) {
    super(store, 'role');
    this.unsetRoles = this.unsetRoles.bind(this);
    this.clearRoles = this.clearRoles.bind(this);
  }

  unsetRoles(id) {
    StoreItemProcessing.deleteItemInStore(this.itemType, id);
  }

  clearRoles() {
    StoreItemProcessing.clearItemsInStore(this.itemType);
  }

  clearState(options) {
    this.clearMyState(this.stateTree.new_roles, options.toIgnore.roles, this.unsetRoles, this.clearRoles, options);
  }
}



// WEBPACK FOOTER //
// ./src/dao/RolesDAO.js